import React from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import parse from "html-react-parser";
import { AlertList } from "react-bs-notifier";
import { v4 as uuidv4 } from "uuid";
import Controls from "../controls/controls";
import md5 from "md5";
import { Link } from "react-router-dom";
import "./config.js";
import Themes from "../themes/themes";

var cloneDeep = require("lodash.clonedeep");

const Functions = {
	alerts: [],

	createRef() {
		return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
			var r = (Math.random() * 16) | 0,
				v = c == "x" ? r : (r & 0x3) | 0x8;
			return v.toString(16);
		});
	},
	KBtoMB(value) {
		return parseFloat(parseFloat(value) / 1000000).toFixed(2);
	},
	getFileTypeIcon(filetype) {
		if (filetype.includes("video")) {
			filetype = "video";
		}

		if (filetype.includes("image")) {
			filetype = "image";
		}

		switch (filetype) {
			case "image":
				return <i className="far fa-file-image fa-2x"></i>;
				break;

			case "application/pdf":
				return <i className="far fa-file-pdf fa-2x"></i>;
				break;

			case "application/msword":
				return <i className="far fa-file-word fa-2x"></i>;
				break;

			case "application/vnd.ms-excel":
				return <i className="far fa-file-excel fa-2x"></i>;
				break;

			case "video":
				return <i className="far fa-file-video fa-2x"></i>;
				break;

			default:
				return <i className="far fa-file fa-2x"></i>;
		}
	},
	pagination(current, start, offset, total, manager, replace, events) {
		let PaginationControl = Controls["pagination"];

		return (
			<PaginationControl
				totalRecords={total}
				current={current}
				start={start}
				offset={offset}
				manager={manager}
				replace={replace}
				property={{ events: events }}></PaginationControl>
		);
	},
	parse(value) {
		return parse(value);
	},
	moduleSearch(manager) {
		let ModuleSearchControl = Controls["modulesearch"];

		return (
			<ModuleSearchControl
				properties={manager.state.module.properties}
				manager={manager}></ModuleSearchControl>
		);
	},
	createAlert(args) {
		if (args.notification) {
			const idx = Functions.alerts.indexOf(args.notification);

			if (idx >= 0) {
				Functions.alerts = [
					...Functions.alerts.slice(0, idx),
					...Functions.alerts.slice(idx + 1),
				];
			}
		} else {
			Functions.alerts.push({
				id: new Date().getTime(),
				type: args.type,
				message: args.message,
			});
		}
		ReactDOM.render(
			<AlertList
				alerts={Functions.alerts}
				timeout={5000}
				onDismiss={(item) => {
					Functions.createAlert({ notification: item });
				}}
			/>,
			document.getElementById("notification-wrapper"),
		);
	},
	link(to, title, className) {
		return (
			<Link
				to={to}
				className={className}>
				{title}
			</Link>
		);
	},
	md5(value) {
		return md5(value);
	},
	REST(args) {
		let API = args.api;

		let url = args.url ? args.url : API.url;
		let headers = args.headers ? args.headers : API.headers;
		let replace = args.replace ? args.replace : API.replace;
		let responseType = args.responseType ? args.responseType : null;
		let params = args.params ? args.params : API.params;
		let mapper = args.mapper ? args.mapper : API.mapper;
		let method = args.method ? args.method : API.method;
		let callback = args.callback;
		let component = args.component;
		let postData = args.postData;

		if (typeof postData === "function") {
			postData = args.postData();
		}

		let data = args.data;
		let parentData = args.parentData;
		let inputData = args.inputData;
		let onUploadProgress = args.onUploadProgress;
		let cancelToken = args.cancelToken;

		if (inputData) {
			if (inputData.length > 0) {
				API.data = inputData;
			}
		}

		let customParameters = args.customParameters ? args.customParameters : null;

		if (customParameters) {
			if (customParameters.replace) {
				Object.keys(customParameters.replace).forEach((itm, idx) => {
					replace[itm] = customParameters.replace[itm];
				});
			}
			if (customParameters.headers) {
				Object.keys(customParameters.headers).forEach((itm, idx) => {
					headers[itm] = customParameters.replace[itm];
				});
			}
		}

		function responseData(
			mapper,
			callback,
			responseData,
			status,
			response,
			error,
			component,
		) {
			let data = responseData;

			if (mapper) {
				data = mapper(data, status, response, error, component);
			}

			if (callback) {
				callback(data, status, response, error, component);
			}
		}

		if (API.data) {
			setTimeout(function () {
				responseData(
					mapper,
					callback,
					API.data,
					"200",
					API.data,
					"",
					component,
				);
			}, 10);
		} else {
			url = Functions.replaceParams(url, replace, data, parentData, component);

			method = Functions.replaceMethod(method, replace, component);

			if (url) {
				if (Functions["custom"]) {
					if (Functions["custom"]["restAPI"]) {
						url = Functions["custom"]["restAPI"](url);
					}
					if (Functions["custom"]["restHeaders"]) {
						headers = Functions["custom"]["restHeaders"](headers);
					}
				}

				// TEMP MOCK - REMOVE BEFORE DELIVERY
				// const mockUrl =
				// 	window.__MI_GET_MOCK_URL__ && window.__MI_GET_MOCK_URL__(url);
				// if (mockUrl) {
				// 	url = mockUrl;
				// 	method = "GET";
				// }

				new axios(
					{
						method: method,
						url: url,
						data: postData ? postData : null,
						headers: headers ? headers : {},
						responseType: responseType,
						params: params ? params : {},
						onUploadProgress: onUploadProgress,
						cancelToken: cancelToken,
					},
					{},
				)
					.then((response) => {
						if (response) {
							let data = response.data;

							if (Functions["custom"]["restCallback"]) {
								Functions["custom"]["restCallback"](
									data,
									response.status,
									response,
									url,
								);
							}

							responseData(
								mapper,
								callback,
								data,
								response.status,
								response,
								"",
								component,
							);
						}
					})
					.catch((error) => {
						console.log(error);
						if (error.response) {
							if (Functions["custom"]["restCallback"]) {
								Functions["custom"]["restCallback"](
									[],
									error.response.status,
									error.response,
								);
							}

							responseData(
								mapper,
								callback,
								[],
								error.response.status,
								error.response,
								error,
								component,
							);
						}
					});
			}
		}
	},

	replaceMethod(method, replaceParams, component) {
		let out = method;
		if (replaceParams) {
			Object.keys(replaceParams).map((itm, idx) => {
				if (typeof replaceParams[itm] === "function") {
					replaceParams[itm] = replaceParams[itm](component);
				}
				try {
					out = out.replace("{" + itm + "}", replaceParams[itm]);
				} catch (e) {}
			});
		}
		return out;
	},

	replaceParams(input, replaceParams, data, parentData, component) {
		let out = input;

		if (replaceParams) {
			Object.keys(replaceParams).map((itm, idx) => {
				if (typeof replaceParams[itm] === "function") {
					replaceParams[itm] = replaceParams[itm](component);
				}
				try {
					out = out.replace("{" + itm + "}", replaceParams[itm]);
				} catch (e) {}
			});
		}

		if (data) {
			Object.keys(data).map((dataItem, dataItemKey) => {
				try {
					out = out.replace("data[" + dataItem + "]", data[dataItem]);
				} catch (e) {}
			});
		}

		if (parentData) {
			Object.keys(parentData).map((dataItem, dataItemKey) => {
				try {
					out = out.replace(
						"parentdata[" + dataItem + "]",
						parentData[dataItem],
					);
				} catch (e) {}
			});
		}

		return out;
	},
	key() {
		return "uuid-".concat(uuidv4());
	},
	getControl(name, component) {
		try {
			let manager = component.props.manager;

			return manager[name + "-ref"].current;
		} catch (e) {
			console.log(e);
		}
		return null;
	},
	getElement(name, component) {
		try {
			let componentDom = ReactDOM.findDOMNode(
				Functions.getControl(name, component),
			);
			return componentDom;
		} catch (e) {
			console.log(e);
		}
		return null;
	},
	clone: function (args) {
		return cloneDeep(args);
	},
	getTemplate(name) {
		let Template = Themes[window["fw_theme"]()][name];

		return Template;
	},
	validate(manager, data) {
		let validator = manager.validator;

		Object.keys(data).map((itm, idx) => {
			let validationControl = manager["validation-" + itm + "-ref"];

			if (validationControl.current) {
				validationControl.current.setState({
					validation: "",
				});
				validator.message(
					"{" + itm + "}",
					data[itm],
					validationControl.current.state.validations,
				);
			}
		});

		if (validator.allValid()) {
			return true;
		} else {
			Object.keys(data).map((itm, idx) => {
				let validationControl = manager["validation-" + itm + "-ref"];
				if (validationControl.current) {
					validationControl.current.setState({
						validation: validator.getErrorMessages()["{" + itm + "}"],
					});
				}
			});
			return false;
		}
	},
	substring(value, start, end) {
		let out = value;

		if (value) {
			if (value.length > end) {
				out = out.substring(start, end) + "...";
			}
		}

		return out;
	},
	createControl(property, manager, data, value) {
		let Control = Controls[property["type"]];

		return (
			<Control
				value={value}
				data={data}
				key={Functions.key()}
				property={property}
				manager={manager}></Control>
		);
	},
	post(e, args) {
		let postData = Functions.getFormJSON(e);
		let method = "POST";

		if (args.postData) {
			postData = args.postData;
		}
		if (args.method) {
			method = args.method;
		}

		Functions.REST({
			api: args.api,
			replace: args.replace ? args.replace : null,
			headers: args.headers ? args.headers : null,
			component: this,
			method: method,
			postData: postData,
			callback: args.callback ? args.callback : null,
		});
	},
	getJSONPath(obj, path) {
		return path.split(".").reduce(function (o, k) {
			return o && o[k];
		}, obj);
	},
	setJSONPath(obj, path, value) {
		var i;
		path = path.split(".");
		for (i = 0; i < path.length - 1; i++) {
			obj = obj[path[i]];
		}
		obj[path[i]] = value;
	},
	dataFormToJSON(e) {
		let data = new FormData(e.target);
		let object = {};
		data.forEach(function (value, key) {
			object[key] = value;
		});
		return object;
	},
	getFormJSON(e) {
		let data = new FormData(e.target);
		var object = {};
		data.forEach(function (value, key) {
			if (key.indexOf("[") >= 0) {
				let keySplit = [];
				keySplit = key
					.replace(/\[/g, "]")
					.split("]")
					.filter(function (el) {
						return el != null && el != "";
					});
				let path = [];
				keySplit.map((it, ix) => {
					path.push(it);
					let pathValue = isNaN(it) ? [] : {};
					pathValue = ix == keySplit.length - 1 ? value : pathValue;
					if (
						typeof Functions.getJSONPath(object, path.join(".")) === "undefined"
					) {
						Functions.setJSONPath(object, path.join("."), pathValue);
					}
				});
			} else {
				object[key] = value;
			}
		});
		return object;
	},
	addScript(src, onload) {
		const script = document.createElement("script");
		script.src = src;
		script.async = false;
		if (onload) {
			script.onload = onload;
		}
		document.body.appendChild(script);
	},
	addCSS(href) {
		const css = document.createElement("link");
		css.type = "text/css";
		css.rel = "stylesheet";
		css.href = href;
		document.getElementsByTagName("head")[0].appendChild(css);
	},
	addCosmoteTelekomCSS() {
		Functions.addCSS("/resources/css/style.css");
		Functions.addCSS("/resources/css/jquery.jscrollpane.css");
		Functions.addCSS("/resources/css/mobile.css");
		Functions.addCSS("/resources/css/custom.css");
		Functions.addCSS("/resources/prepaid/css/telekom.css");
	},
	addHybridWalletCSS(UserType, inListOfWhatuspCss) {
		const links = [
			"/resources/hybrid_wallets/css/style.css",
			"/resources/hybrid_wallets/css/jquery.jscrollpane.css",
			"/resources/hybrid_wallets/css/mobile.css",
		];
		if (UserType !== "HYBRID_BUSINESS_COST_CONTROL") {
			if (inListOfWhatuspCss) {
				links.push("/resources/hybrid_wallets/css/whatsup.css");
				links.push("/resources/hybrid_wallets/css/hybrid-wallet-whatsup.css");
			} else {
				links.push("/resources/hybrid_wallets/css/hybrid-wallet-cc.css");
			}
		} else {
			links.push("/resources/hybrid_wallets/css/hybrid-wallet-bcc.css");
		}
		links.forEach((href) => {
			const css = document.createElement("link");
			css.rel = "stylesheet";
			css.type = "text/css";
			css.href = href;
			css.dataset.hybridWallet = "true";
			document.head.appendChild(css);
		});
		document.body.classList.add("hybrid-detail-open");
	},
	removeHybridWalletCSS() {
		document
			.querySelectorAll('link[data-hybrid-wallet="true"]')
			.forEach((el) => el.parentNode.removeChild(el));
		document.body.classList.remove("hybrid-detail-open");
	},
	enrichData(args) {
		let module = args.module;
		let properties = module.properties;
		let primaryKey = module.primaryKey;
		let templateConfiguration = module.templateConfiguration;

		let includeProperties = [];
		let excludeProperties = [];

		if (templateConfiguration) {
			includeProperties = templateConfiguration.includeProperties
				? templateConfiguration.includeProperties
				: [];
			excludeProperties = templateConfiguration.excludeProperties
				? templateConfiguration.excludeProperties
				: [];
		}

		let data = args.data;

		let manager = args.manager;

		let enrichedData = [];

		try {
			if (includeProperties.length > 0) {
				let sortedProperties = {};
				includeProperties.map((itm, idx) => {
					if (properties[itm]) {
						sortedProperties[itm] = properties[itm];
					}
				});

				Object.keys(properties).map((itm, idx) => {
					if (!sortedProperties[itm]) {
						sortedProperties[itm] = properties[itm];
					}
				});

				properties = sortedProperties;
			}

			if (data) {
				if (data.length > 0) {
					data.map((record, idxRec) => {
						let formattedProperty = {};
						Object.keys(properties).map((itm, idx) => {
							let property = { ...properties[itm] };
							property["validator"] = manager.validator;

							let refPrimaryKey = property["alias"] + "-ref";
							let dataRecord = { ...record };
							let editable = property["editable"];
							let value = record[property["alias"]];
							let alias = property["alias"];
							if (typeof editable !== "undefined") {
								if (typeof editable === "function") {
									property["editable"] = property["editable"]({
										data: dataRecord,
										property: property,
										manager: manager,
									});
								}
							}
							let Control = Controls[property["type"]];

							let showPropertyOnTemplate = true;
							if (excludeProperties.length > 0) {
								showPropertyOnTemplate =
									excludeProperties.indexOf(itm) >= 0 ? false : true;
							}
							if (includeProperties.length > 0) {
								showPropertyOnTemplate =
									includeProperties.indexOf(itm) >= 0 ? true : false;
							}

							manager[refPrimaryKey] = React.createRef();
							manager["validation-" + refPrimaryKey] = React.createRef();

							let ValidationComponent = null;

							if (property["validations"]) {
								let ValidationControl = Controls["validationcontrol"];

								ValidationComponent = (
									<ValidationControl
										{...property}
										key={Functions.key()}
										ref={
											manager["validation-" + refPrimaryKey]
										}></ValidationControl>
								);
							}

							formattedProperty[alias] = {
								value: value,
								showPropertyOnTemplate: showPropertyOnTemplate,
								component: (
									<Control
										value={value}
										data={dataRecord}
										key={Functions.key()}
										property={property}
										primaryKey={record[primaryKey]}
										ref={manager[refPrimaryKey]}
										manager={manager}
										validationComponent={
											ValidationComponent ? ValidationComponent : null
										}></Control>
								),
								validationComponent: ValidationComponent
									? ValidationComponent
									: null,
								data: dataRecord,
								property: property,
							};
						});
						enrichedData.push(formattedProperty);
					});
				}
			}
		} catch (e) {
			console.log(e);
		}
		return enrichedData;
	},
	getParameterByName(name, url = window.location.href) {
		name = name.replace(/[\[\]]/g, "\\$&");
		var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return "";
		return decodeURIComponent(results[2].replace(/\+/g, " "));
	},
	getQueryPath(index, url = window.location.pathname) {
		let splitUrl = url.split("/");

		return splitUrl[index];
	},
	getPath(url = window.location.pathname) {
		return url;
	},
	theme: {},
	custom: {},
};

function appendThemeAndCustomFunctions() {
	try {
		const ThemeFunctions = require(
			"../themes/" + window["fw_theme"]() + "/functions",
		);
		if (ThemeFunctions) {
			if (ThemeFunctions.default) {
				Object.keys(ThemeFunctions.default).map((itm, idx) => {
					Functions["theme"][itm] = ThemeFunctions.default[itm];
				});
			}
		}
	} catch (e) {}
	try {
		const CustomFunctions = require("../modules/functions");
		if (CustomFunctions) {
			if (CustomFunctions.default) {
				Object.keys(CustomFunctions.default).map((itm, idx) => {
					Functions["custom"][itm] = CustomFunctions.default[itm];
				});
			}
		}
	} catch (e) {}
}

appendThemeAndCustomFunctions();

export default Functions;
